<section style="color: var(--page-accent);">
  <div *ngFor="let slotable of contentModule.slotables, let odd = odd" class="mt-8 sm:mt-12 w-full">
    <app-slot-a61
      [slotable]="slotable"
      [image]="contentModule.image"
    ></app-slot-a61>
  </div>
</section>

